import React from "react";
import styled from "styled-components";


export default styled.span`
    flex: 1 1 auto;
    white-space: nowrap;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 61px;
    color: rgb(136 136 136);
    font-weight: 700;
    position: relative;
    box-sizing: border-box;
    padding: 15px;

    @media(max-width: 1553px) {
        width: 13%;
    }

    @media(max-width: 1024px) {
        width: 38%;
    }
`;
